// 章節序號:「第幾個」→「一、二、三」。
//
// 業主 2026-09-11 決定序號不由使用者填,一律依分類順序推導。
// 後端 app/numbering.py 有一份一模一樣的規則,存檔時由它寫進 quote_sections.code
// (PDF 與 XLSX 的封面讀那一欄)。
//
// 前端這一份是給畫面用的:新增或搬動分類時,序號要當場就對,
// 不必等存檔繞一趟後端。兩邊的規則必須一致,各自有測試釘住同一組數字。

const DIGITS = "〇一二三四五六七八九";

/** 0 起算的位置換成中文序號。0→一、9→十、10→十一、19→二十、20→二十一。 */
export function sectionCode(index: number): string {
  if (!Number.isFinite(index) || index < 0) return "";

  const n = Math.floor(index) + 1;
  if (n <= 10) return n === 10 ? "十" : DIGITS[n];
  if (n < 100) {
    const tens = Math.floor(n / 10);
    const ones = n % 10;
    const head = tens === 1 ? "十" : `${DIGITS[tens]}十`;
    return head + (ones ? DIGITS[ones] : "");
  }
  // 沒有人會在一張報價單上開一百個分類,真的開了也不該吐出怪字。
  return String(n);
}
